module.exports = __webpack_public_path__ + "static/img/dialog-bg-3.0af90a1c.png";